import { render, staticRenderFns } from "./LayoutColumn.vue?vue&type=template&id=516f47e9&scoped=true&"
import script from "./LayoutColumn.vue?vue&type=script&lang=js&"
export * from "./LayoutColumn.vue?vue&type=script&lang=js&"
import style0 from "./LayoutColumn.vue?vue&type=style&index=0&id=516f47e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f47e9",
  null
  
)

export default component.exports